export default "__VITE_ASSET__BzqEvjun__"